export const checkValidity = (
    input,
    reportValidity,
    controllerProp = '_validationController',
    internalsProp = '_internals'
) => {
    const controller = input[controllerProp];
    const isValid = controller.validate();

    if (!isValid) {
        input.setAttribute('error', '');
        input.setAttribute('error-text', controller.getErrorMessage());
    } else {
        input.removeAttribute('error');
        input.removeAttribute('error-text');
    }

    input.requestUpdate?.();

    if (!isValid && reportValidity) {
        const internals = input[internalsProp];
        internals.reportValidity();
    }

    return isValid;
};
